import { createFileRoute } from '@tanstack/react-router';

import SlideshowContent from '../-components/SlideshowContent';

// Pathless, so the content stays mounted while a slide modal opens on top of it
export const Route = createFileRoute('/_authenticated/slideshows/$id/_content')({
    component: SlideshowContent,
});
